import { HttpErrorResponse } from '@angular/common/http';

export const PROJECT_IS_PROCESSING_TAG = 'ERROR__PROJECT_IS_PROCESSING';
export const PROJECT_SELECTION_ROUTE = '/project';

/** True when the server blocked a request because the project is Processing/Upgrading. */
export function isProjectProcessingError(error: HttpErrorResponse): boolean {
    if (!error || error.status !== 403 || !error.headers) {
        return false;
    }
    const reasonRaw = error.headers.get('REASON');
    if (!reasonRaw) {
        return false;
    }
    try {
        return JSON.parse(reasonRaw)?.tag === PROJECT_IS_PROCESSING_TAG;
    } catch {
        return false;
    }
}
